
import { defineComponent, ref, onMounted, watch } from "vue";
import { storage } from "@/firebase";
import { ref as storageRef, getDownloadURL } from "firebase/storage";

export default defineComponent({
  name: "MediaDisplay",
  props: {
    mediaType: {
      type: String,
      required: true,
    },
    storagePath: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const mediaUrl = ref<string | null>(null);
    const isLoading = ref(false);
    const error = ref(false);
    const uniqueId = ref(`img-${Math.random().toString(36).substr(2, 9)}`);

    const loadMediaUrl = async () => {
      if (!props.storagePath) {
        return;
      }

      isLoading.value = true;
      error.value = false;

      try {
        const pathRef = storageRef(storage, props.storagePath);
        const url = await getDownloadURL(pathRef);
        mediaUrl.value = url;
      } catch (err) {
        console.error("Error loading media from storage:", err);
        error.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    const handleImageError = () => {
      error.value = true;
    };

    const handleVideoError = () => {
      error.value = true;
    };

    const openImageModal = () => {
      // Modal will be opened by Bootstrap's data-bs-toggle
    };

    const openVideoModal = () => {
      // Modal will be opened by Bootstrap's data-bs-toggle
    };

    const pauseVideo = () => {
      const videoElement = document.getElementById(
        `video-player-${uniqueId.value}`
      ) as HTMLVideoElement;
      if (videoElement) {
        videoElement.pause();
      }
    };

    onMounted(() => {
      loadMediaUrl();
    });

    // Watch for changes in storagePath
    watch(
      () => props.storagePath,
      () => {
        loadMediaUrl();
      }
    );

    return {
      mediaUrl,
      isLoading,
      error,
      uniqueId,
      handleImageError,
      handleVideoError,
      openImageModal,
      openVideoModal,
      pauseVideo,
    };
  },
});
